import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type ICardRootProps = HTMLAttributes<HTMLDivElement>;

export function CardRoot({
  children,
  className,
  ...rest
}: PropsWithChildren<ICardRootProps>) {
  return (
    <div className={twMerge('', className)} {...rest}>
      {children}
    </div>
  );
}
